<template>
  <a class="link" :href="phoneNumberLink">
    <slot v-if="isCircle" name="phoneIcon" />
    <slot v-else name="expandedPhoneIcon">
      <img :src="require(`../assets/icons/${phoneIcon}`)" class="phone-icon" alt="Bionic phone">
    </slot>
    <span v-if="!isCircle" class="number" :class="`number--${colorTheme}`">{{ phoneNumber }}</span>
  </a>
</template>

<script>
export default {
  name: 'PhoneIcon',

  props: {
    isCircle: {
      type: Boolean,
      default: false
    },

    phoneNumber: {
      type: String,
      required: true
    },
    phoneIcon: {
      type: String,
      default: 'call-light.svg'
    },
    colorTheme: {
      type: String,
      default: ''
    }
  },

  computed: {
    phoneNumberLink () {
      const normalizedNumber = this.phoneNumber.replace(/\s/g, '')

      return `tel:${normalizedNumber}`
    }
  }
}
</script>

<style lang="scss" scoped>
.circle {
  width: 24px;
  opacity: 0.7;
  display: block;

  @media (max-width: $screen-md) {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
}

.number {
  margin-left: $spacing-4;
  font-size: 24px;
  color: $white;
  text-decoration: none;

  &--purple {
    color: $purple-1;
  }

  .light & {
    color: $white;
  }

  @media (max-width: $screen-md) {
    font-size: 20px;
  }
}

.phone-icon {
  height: $nav-bar-phone-icon-height;

  @media (max-width: $screen-md) {
    height: calc(#{$nav-bar-phone-icon-height} * 0.86);
  }
  @media (max-width: $screen-sm) {
    height: 23px;
  }
}

.link {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: $screen-md) {
    margin-top: 5px;
    margin-bottom: -8px;
  }

  @media (max-width: $screen-sm) {
    margin-top: inherit;
    margin-bottom: inherit;
  }
}

#group-5 {
  fill: blue;
}

#group-6 {
  fill: yellow;
}
</style>
